import { Controller } from "react-hook-form";
import { InputDropdown } from "@onengine/component-library";
import { Stack } from "@mantine/core";
import { OtherTextInput } from "./OtherTextInput";
import type { ControlledFieldProps } from "./types";

const OTHER_VALUE = "__other__";

export function ControlledSelect({
  name,
  control,
  error,
  clearErrors,
  data,
  placeholder,
  allowOther,
}: ControlledFieldProps & {
  data: { value: string; label: string }[];
  placeholder?: string;
  allowOther?: boolean;
}) {
  const filteredData = allowOther ? data.filter((o) => o.label !== "Other") : data;
  const dropdownItems = allowOther
    ? [...filteredData, { value: OTHER_VALUE, label: "Other" }]
    : filteredData;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => {
        const isOtherSelected = field.value === OTHER_VALUE;

        return (
          <Stack gap="xs">
            <InputDropdown
              mode="single"
              value={field.value || null}
              onChange={(v) => {
                field.onChange(v);
                clearErrors(name);
              }}
              items={dropdownItems}
              placeholder={placeholder || "Select an option"}
              size="small"
              error={error}
            />
            {allowOther && isOtherSelected && (
              <OtherTextInput name={`${name}__other`} control={control} />
            )}
          </Stack>
        );
      }}
    />
  );
}
